export default __webpack_public_path__ + "static/media/banner-who-we-are.c6e3e8bf.png";